    <div class="match-category-candidate" [attr.data-qa-id]="dataQaId">
        {{candidateName}} is a {{matchCategory?.toUpperCase()}} match for this job
    </div>
